var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatePackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "118px",
    height: "118px",
    viewBox: "0 0 118 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconmonstr-video-9 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latest-Version",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-video-9-copy",
    fill: "#C3C3C3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1666667,98.3333333 L49.1666667,68.8333333 L73.75,83.5833333 L49.1666667,98.3333333 Z M118,21.5104167 L117.960667,21.3039167 L113.004667,0 L8.92375,20.6303333 C3.74158333,21.6579167 -2.18343862e-15,26.2058333 -2.18343862e-15,31.4814167 L-2.18343862e-15,103.25 C-2.18343862e-15,111.396917 6.60308333,118 14.75,118 L103.25,118 C111.392,118 118,111.396917 118,103.25 L118,34.4166667 L55.3911667,34.4166667 L118,21.5104167 Z M98.8741667,8.63858333 L110.6545,16.5249167 L95.934,19.4503333 L84.1438333,11.5590833 L98.8741667,8.63858333 Z M69.8805833,14.3861667 L81.6756667,22.2823333 L66.9600833,25.20775 L55.15025,17.3066667 L69.8805833,14.3861667 Z M40.8476667,20.1435833 L52.6624167,28.0495833 L37.9468333,30.975 L26.1173333,23.0591667 L40.8476667,20.1435833 L40.8476667,20.1435833 Z M53.3261667,39.3333333 L43.3010833,49.1666667 L28.2855833,49.1666667 L38.3106667,39.3333333 L53.3261667,39.3333333 Z M97.468,39.3333333 L112.4835,39.3333333 L102.463333,49.1666667 L87.4429167,49.1666667 L97.468,39.3333333 Z M67.909,39.3333333 L82.9195833,39.3333333 L72.8945,49.1666667 L57.8839167,49.1666667 L67.909,39.3333333 L67.909,39.3333333 Z M108.166667,59 L108.166667,102.020833 C108.166667,105.413333 105.413333,108.166667 102.020833,108.166667 L15.9791667,108.166667 C12.5866667,108.166667 9.83333333,105.413333 9.83333333,102.020833 L9.83333333,59 L108.166667,59 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePackageIcon);
export default __webpack_public_path__ + "static/media/create-package-icon.00db85f3e3119fbc6f899004ec77f0f6.svg";
export { ForwardRef as ReactComponent };